import React from 'react'
import Radio from '@material-ui/core/Radio'
import RadioGroup from '@material-ui/core/RadioGroup'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import FormControl from '@material-ui/core/FormControl'
import FormLabel from '@material-ui/core/FormLabel'

export default props => {
  const {
    label,
    options,
    value = '',
    onChange,
  } = props

  return (
    <FormControl component='fieldset'>
      <FormLabel component='legend'>
        {label}
      </FormLabel>
      <RadioGroup
        aria-label='position'
        name='position'
        row
      >
        {options.map((option, index) => (
          <FormControlLabel
            key={String(index)}
            control={(
              <Radio
                color='secondary'
                onChange={event => onChange(event, option)}
                checked={option.value === value}
              />
            )}
            label={option.label}
            labelPlacement='start'
          />
        ))}
      </RadioGroup>
    </FormControl>
  )
}
